import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Input, message, Modal, Row, Switch } from "antd";

import { functionsService } from "../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
	UIInfoBanner,
	UISwitchField,
} from "./../../components";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

export const FunctionStatusField = () => (
	<Form.Item label="Status" required>
		<UISwitchField
			bordered
			title="Ativo"
			description="Funções inativas não podem ser vinculadas a novos funcionários.">
			<Form.Item name="ativo" valuePropName="checked" noStyle>
				<Switch />
			</Form.Item>
			<Form.Item noStyle shouldUpdate={(prev, next) => prev.ativo !== next.ativo}>
				{({ getFieldValue }) => (
					<span className={`status-tag ${getFieldValue("ativo") ? "status-tag-success" : "status-tag-error"}`}>
						<i className="status-tag-dot" />
						{getFieldValue("ativo") ? "Função ativa" : "Função inativa"}
					</span>
				)}
			</Form.Item>
		</UISwitchField>
	</Form.Item>
);

export const FunctionsInfoBanner = () => (
	<UIInfoBanner
		icon={<i className="fal fa-info-circle" />}
		title="Sobre funções"
		description="As funções identificam o cargo de cada funcionário e são escolhidas no contrato, ao cadastrar ou editar um funcionário."
	/>
);

class Create extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isSending: false,
		};
	}

	onOpen = () => {
		setTimeout(() => {
			this.nome && this.nome.focus()
		}, 100)
	};

	onClose = () => {
		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		this.setState({
			isSending: true,
		});

		functionsService.create(values)
			.then((response) => {
				this.setState({
					isSending: false,
				});

				// Success message
				message.success("Função cadastrada com sucesso.");

				// Callback
				this.props.onComplete();
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	render() {
		const { visible } = this.props;

		const { isLoading, isSending } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-user-tie" />}
				title="Incluir nova função"
				subtitle="Cadastre uma nova função/cargo na empresa."
				btnSaveText="Salvar função">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}
					initialValues={{
						ativo: true,
					}}>
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais"
						description="Dados de identificação da função.">
						<Row gutter={16}>
							<Col xs={24}>
								<Form.Item
									name="nome"
									label="Nome da função"
									extra="Informe o nome que identifica esta função/cargo na empresa."
									hasFeedback
									rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Input ref={el => this.nome = el} placeholder="Digite o nome da função" />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<FunctionStatusField />
							</Col>
						</Row>
					</UIFormSection>
					<FunctionsInfoBanner />
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Create;
